export enum BenefitType {
  DENTAL = 'DENTAL',
  FITNESS = 'FITNESS',
  OTC = 'OTC',
  VISION = 'VISION',
}

export enum UserBenefitRequestStatus {
  SUBMITTED = 'SUBMITTED',
  PROCESSING = 'PROCESSING',
  WAITING_FOR_INFO = 'WAITING_FOR_INFO',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}

export interface DashboardBenefit {
  benefit_info: any;
  carrier_name: string;
  catalog_id?: string;
  id: string;
  status?: UserBenefitRequestStatus;
  type: BenefitType;
}
